import { render, staticRenderFns } from "./SocialAuthCallback.vue?vue&type=template&id=5870ece8&"
import script from "./SocialAuthCallback.vue?vue&type=script&lang=js&"
export * from "./SocialAuthCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports